"use client";

import { useEffect, useState } from "react";

import { observer } from "mobx-react-lite";
import { useRouter } from "next/navigation";

import { RequireAuth } from "@/components/auth/RequireAuth";
import { useStore } from "@/store";
import { docPageUrl } from "@/urls";
import { getFirstDocumentOfTeam } from "@/utils/getFirstDocumentOfTeam";
import { trackEvent } from "@/utils/trackEvent";

const RedirectToIntroPage = observer(function RedirectToIntroPage() {
  const router = useRouter();
  const { auth, documentTree, signInFlow } = useStore();
  // We need it to avoid infinite redraw in tests.
  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    if (!redirected && documentTree.team) {
      const { team } = documentTree;
      const firstDocument = getFirstDocumentOfTeam(team);
      setRedirected(true);
      if (firstDocument && firstDocument.typename === "DocumentShort") {
        trackEvent("getting_started_page_viewed", {
          doc_id: firstDocument.uid,
          team_uid: team.uid,
          team_kind: team.kind,
        });
        router.push(docPageUrl({ docId: firstDocument.uid }));
      } else {
        signInFlow.redirectAfterLogin();
      }
    }
  }, [redirected, auth, router, documentTree.team, signInFlow]);

  return null;
});

function Page() {
  return (
    <RequireAuth noRedirectBack>
      <RedirectToIntroPage />
    </RequireAuth>
  );
}

export default Page;
